import imgHome from '../../../static/image/menu_home_w.svg';
import imgHomeActive from '../../../static/image/menu_home_w_active.svg';
import imgBook from '../../../static/image/menu_minibook_w.svg';
import imgBookActive from '../../../static/image/menu_minibook_w_active.svg';
import imgMemo from '../../../static/image/menu_memo_w.svg';
import imgMemoActive from '../../../static/image/menu_memo_w_active.svg';
import imgTogether from '../../../static/image/menu_together_w.svg';
import imgTogetherActive from '../../../static/image/menu_together_w_active.svg';
import imgYouBooker from '../../../static/image/menu_youbooker_w.svg';
import imgYouBookerActive from '../../../static/image/menu_youbooker_w_active.svg';

import imgHomeDark from '../../../static/image/menu_home_d.svg';
import imgHomeDarkActive from '../../../static/image/menu_home_d_active.svg';
import imgBookDark from '../../../static/image/menu_minibook_d.svg';
import imgBookDarkActive from '../../../static/image/menu_minibook_d_active.svg';
import imgMemoDark from '../../../static/image/menu_memo_d.svg';
import imgMemoDarkActive from '../../../static/image/menu_memo_d_active.svg';
import imgTogetherDark from '../../../static/image/menu_together_d.svg';
import imgTogetherDarkActive from '../../../static/image/menu_together_d_active.svg';
import imgYouBookerDark from '../../../static/image/menu_youbooker_d.svg';
import imgYouBookerDarkActive from '../../../static/image/menu_youbooker_d_active.svg';

export const menuIcons = {
  home: {
    light: { default: imgHome, active: imgHomeActive },
    dark: { default: imgHomeDark, active: imgHomeDarkActive },
  },
  book: {
    light: { default: imgBook, active: imgBookActive },
    dark: { default: imgBookDark, active: imgBookDarkActive },
  },
  memo: {
    light: { default: imgMemo, active: imgMemoActive },
    dark: { default: imgMemoDark, active: imgMemoDarkActive },
  },
  together: {
    light: { default: imgTogether, active: imgTogetherActive },
    dark: { default: imgTogetherDark, active: imgTogetherDarkActive },
  },
  youbooker: {
    light: { default: imgYouBooker, active: imgYouBookerActive },
    dark: { default: imgYouBookerDark, active: imgYouBookerDarkActive },
  },
};

export const getMenuImage = (menuKey, isActive, isDarkMode) => {
  const theme = isDarkMode ? 'dark' : 'light';
  const state = isActive ? 'active' : 'default';
  return menuIcons[menuKey][theme][state];
};
